module.exports = __webpack_public_path__ + "assets/img/webLogo.574d94a4.png";